module.exports = __webpack_public_path__ + "img/close@3x.44150777.png";